import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/styles/_header.scss";

type Props = {
  children: React.ReactElement;
};

export const Header = (props: Props): React.ReactElement => {
  const [menuActive, setMenuActive] = useState(false);
  const menu = [
    {
      title: "選ばれる理由",
      href: "/lp",
    },
    {
      title: "コンサルタント紹介",
      href: "/consultant",
    },
    {
      title: "プライバシーポリシー",
      href: "/privacy",
    },
    {
      title: "会社概要",
      href: "/company",
    },
    {
      title: "コラム",
      href: "/column",
    },
    // {
    //   title: "採用情報",
    //   href: "",
    // },
    {
      title: "お知らせ",
      href: "/news",
    },
  ];
  useEffect(() => {
    if (menuActive) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";
  }, [menuActive]);
  return (
    <header>
      <section className={`header-menu  ${menuActive ? "active" : ""}`}>
        <div className="company-title">
          <p>未来へ繋ぐ資産運用</p>
          <h1>ドリミット株式会社</h1>
        </div>
        <div className="inner">
          <h3>MENU</h3>
          <ul>
            {menu.map((item, index) => {
              return (
                <li key={index}>
                  <Link to={item.href}>{item.title}</Link>
                </li>
              );
            })}
          </ul>
          <div className="header-cta_box">
            <Link to="/contact" className="mail-box">
              <p>
                メールでの
                <br />
                お問い合わせはこちら
              </p>
              <p className="circle"></p>
            </Link>
            <a href="tel:03-5817-4752" className="tel-box">
              <p>お電話でのお問い合わせ</p>
              <div className="number">
                <p>０３ - ５８１７ - ４７５２</p>
                <span>
                  受付時間：10:00〜19:00
                  <br />
                  定休日：毎週火曜日
                </span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section className="kv-top">
        <div className="company-title">
          <Link to="/">
            <p>未来へ繋ぐ資産運用</p>
            <h1>ドリミット株式会社</h1>
          </Link>
        </div>
        <div
          className="hamburger-menu"
          onClick={() => setMenuActive(!menuActive)}
        >
          <label className={`menu-btn  ${menuActive ? "active" : ""}`}>
            <span></span>
          </label>
        </div>
      </section>
      {props.children}
    </header>
  );
};
